const requestConfig = {};
const corpIdMap = {
  localhost: 'ww026189ab05972f25',
  yxtechai: 'ww026189ab05972f25'
};
let corpId = 'ww026189ab05972f25';
Object.keys(corpIdMap).forEach(key => {
  if (window.location.href.includes(key)) {
    corpId = corpIdMap[key];
  }
});

requestConfig.API_REQUEST_CONTENT_TYPE = 'application/json'; // 通用请求类型
requestConfig.API_REQUEST_TIMEOUT = 600000; // 接口超时时间
requestConfig.API_SUCCESS_CODE = '000000'; // 接口返回成功码
requestConfig.API_EXPIRED_CODE = '100013'; // 鉴权失败码
requestConfig.EXPIRED_TO_URL = `/#/login`; // 鉴权失败跳转地址
// requestConfig.API_REQUEST_HEADERS = {
//   corpId: corpId
// };

export default requestConfig;
